import type { Permission } from '@/data'
import api from '.'
import type { PermissionPayload } from './createPermission'

export async function updatePermission(
  id: string,
  payload: Partial<PermissionPayload>,
): Promise<Permission> {
  const res = await api.put(`/${id}`, payload)
  return res.data.data
}
